import { IKnmInspector248 } from 'APIPackage/KnmModule/interfaces/IKnmInspector248';

import { IKnmErknmFormInspector } from '../interfaces/IKnmErknmFormInspector';

type DataType = IKnmInspector248[] | null;

export function convertInspectorsFormValuesToKnmDataOld(formInspectors?: IKnmErknmFormInspector[] | null): DataType {
  return (
    formInspectors?.map(item => {
      const formInspector: IKnmInspector248 = {
        fullName: item.fullName || '',
        position: !item.position?.value
          ? null
          : {
              ...item.position.value,
              inspectionResult: item.position.inspectionResult,
            },
        guid: item.guid || null,
        dateCreate: item.dateCreate || null,
      };

      return formInspector;
    }) || null
  );
}
